export default {
  themeBlue: "#00acc1",
  darkGrey: "#505050",
  lightGrey: "#cdcdcd",
  red: "#FF0000",
  white: "#fff"
};
